var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcNormalCharger2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.152,
    height: 10.481,
    viewBox: "0 0 9.152 10.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-1864.951 -2070.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1871.1,2071.419v-.589h-.619v.412a4.474,4.474,0,0,0-.9-.1,4.569,4.569,0,0,0-1.012.1v-.414h-.619v.594a4.575,4.575,0,0,0,.255,8.676v.994a.217.217,0,0,0,.217.217h2.208a.217.217,0,0,0,.217-.217v-.994a4.577,4.577,0,0,0,.249-8.681Zm-.6,8.252v.86a.217.217,0,0,1-.217.217h-1.5a.217.217,0,0,1-.217-.217v-.86a4.022,4.022,0,0,1-3.1-3.849,4.069,4.069,0,1,1,8.138-.047A4.02,4.02,0,0,1,1870.5,2079.671Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1871.418,2076.785a.21.21,0,1,0,.209.21A.21.21,0,0,0,1871.418,2076.785Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1867.6,2074.367a.326.326,0,1,0,.326.326A.326.326,0,0,0,1867.6,2074.367Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M1867.67,2076.785a.21.21,0,1,0,.21.21A.209.209,0,0,0,1867.67,2076.785Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1869.517,2077.509a.325.325,0,1,0,.326.326A.326.326,0,0,0,1869.517,2077.509Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M1869.527,2072.255a3.461,3.461,0,1,0,3.461,3.461A3.461,3.461,0,0,0,1869.527,2072.255Zm-1.857,5.3a.564.564,0,1,1,.564-.563A.563.563,0,0,1,1867.67,2077.558Zm.672-2.125a1.056,1.056,0,1,1-.129-1.338A.959.959,0,0,1,1868.342,2075.433Zm1.175,3.439a1.056,1.056,0,1,1,.855-1.037A.96.96,0,0,1,1869.517,2078.872Zm1.9-1.314a.564.564,0,1,1,.563-.563A.563.563,0,0,1,1871.418,2077.558Zm-.734-2.132a1.057,1.057,0,1,1,1.338-.129A.96.96,0,0,1,1870.684,2075.426Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1871.418,2074.361a.325.325,0,1,0,.325.325A.325.325,0,0,0,1871.418,2074.361Z",
    fill: "#3d3d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNormalCharger2);
export default __webpack_public_path__ + "static/media/ic-normal-charger-2.a7a09e1b0c4a3f45e46935c6c3a4ee32.svg";
export { ForwardRef as ReactComponent };